export function isAgentConnectionError(errorMessage = '') {
  const normalized = String(errorMessage || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();

  return (
    normalized.includes('no se ha podido conectar con ewu print agent')
    || normalized.includes('revisa que este instalado')
    || normalized.includes('failed to fetch')
    || normalized.includes('network')
    || normalized.includes('cors')
    || normalized.includes('abort')
    || normalized.includes('timeout')
  );
}
